var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import Golomb from './golomb';

var SPSParser = function () {
  function SPSParser() {
    _classCallCheck(this, SPSParser);
  }

  _createClass(SPSParser, null, [{
    key: '_ebsp2rbsp',
    value: function _ebsp2rbsp(uint8array) {
      var src = uint8array;
      var srcLength = src.byteLength;
      var dst = new Uint8Array(srcLength);
      var dstIdx = 0;

      for (var i = 0; i < srcLength; i++) {
        if (i >= 2) {
          if (src[i] === 0x03 && src[i - 1] === 0x00 && src[i - 2] === 0x00) {
            continue;
          }
        }
        dst[dstIdx] = src[i];
        dstIdx++;
      }

      return new Uint8Array(dst.buffer, 0, dstIdx);
    }
  }, {
    key: 'parseVPS',
    value: function parseVPS(uint8array, hvcC) {
      hvcC = hvcC || {};
      var rbsp = SPSParser._ebsp2rbsp(uint8array);
      var gb = new Golomb(rbsp);

      gb.readByte(); // NAL header
      gb.readByte();

      gb.readBits(12);
      var vpsMaxSubLayersMinus1 = gb.readBits(3);
      hvcC.numTemporalLayers = Math.max(hvcC.numTemporalLayers || 0, vpsMaxSubLayersMinus1 + 1);
      gb.readBits(17);
      SPSParser._readProfileTierLevel(gb, vpsMaxSubLayersMinus1, hvcC);

      return hvcC;
    }
  }, {
    key: 'parseSPS',
    value: function parseSPS(uint8array, hvcC) {
      hvcC = hvcC || {};
      var rbsp = SPSParser._ebsp2rbsp(uint8array);
      var gb = new Golomb(rbsp);

      var vpsId = 0,
          maxSubLayersMinus1 = 0,
          tINf = 0,
          spsId = 0,
          separate_colour_plane_flag = 0,
          chromaFormatIdc = 0,
          width = 0,
          height = 0,
          conf_win_left_offset = 0,
          conf_win_right_offset = 0,
          conf_win_top_offset = 0,
          conf_win_bottom_offset = 0,
          conformanceWindowFlag = 0,
          bitDepthLumaMinus8 = 0,
          bitDepthChromaMinus8 = 0,
          sub_width_c = 0,
          sub_height_c = 0,
          profileTierLevel = {};

      gb.readByte(); // NAL header
      gb.readByte();

      vpsId = gb.readBits(4); // vps_id
      maxSubLayersMinus1 = gb.readBits(3); // max_sub_layers_minus1
      hvcC.numTemporalLayers = Math.max(maxSubLayersMinus1 + 1, hvcC.numTemporalLayers || 0);
      hvcC.temporalIdNested = tINf = gb.readBits(1); // temporal_id_nesting_flag

      profileTierLevel = SPSParser._readProfileTierLevel(gb, maxSubLayersMinus1, hvcC);

      spsId = gb.readUEG(); // sps id
      hvcC.chromaFormatIdc = chromaFormatIdc = gb.readUEG();
      if (chromaFormatIdc === 3) {
        separate_colour_plane_flag = gb.readBits(1); // separate_colour_plane_flag
      }

      width = gb.readUEG(); // pic_width_in_luma_samples
      height = gb.readUEG(); // pic_height_in_luma_samples

      conformanceWindowFlag = gb.readBits(1);
      if (conformanceWindowFlag === 1) {
        conf_win_left_offset = gb.readUEG(); // conf_win_left_offset
        conf_win_right_offset = gb.readUEG(); // conf_win_right_offset
        conf_win_top_offset = gb.readUEG(); // conf_win_top_offset
        conf_win_bottom_offset = gb.readUEG(); // conf_win_bottom_offset
      }

      hvcC.bitDepthLumaMinus8 = bitDepthLumaMinus8 = gb.readUEG(); // bit_depth_luma_minus8
      hvcC.bitDepthChromaMinus8 = bitDepthChromaMinus8 = gb.readUEG(); // bit_depth_chroma_minus8

      if (conformanceWindowFlag === 1) {
        sub_width_c = (1 === chromaFormatIdc || 2 === chromaFormatIdc) && 0 === separate_colour_plane_flag ? 2 : 1;
        sub_height_c = 1 === chromaFormatIdc && 0 === separate_colour_plane_flag ? 2 : 1;
        width -= sub_width_c * conf_win_right_offset + sub_width_c * conf_win_left_offset;
        height -= sub_height_c * conf_win_bottom_offset + sub_height_c * conf_win_top_offset;
      }

      gb.destroy();
      gb = null;

      return { width: width, height: height,
        general_profile_space: profileTierLevel.general_profile_space,
        general_tier_flag: profileTierLevel.general_tier_flag,
        general_profile_idc: profileTierLevel.general_profile_idc,
        general_level_idc: profileTierLevel.general_level_idc,
        chromaFormatIdc: chromaFormatIdc,
        bitDepthLumaMinus8: bitDepthLumaMinus8,
        bitDepthChromaMinus8: bitDepthChromaMinus8,
        hvcC: hvcC
      };
    }
  }, {
    key: '_readProfileTierLevel',
    value: function _readProfileTierLevel(gb, maxSubLayersMinus1, hvcC) {
      var generalTierFlag = hvcC.generalTierFlag || 0;
      hvcC.generalProfileSpace = gb.readBits(2);
      hvcC.generalTierFlag = Math.max(gb.readBits(1), generalTierFlag);
      hvcC.generalProfileIdc = Math.max(gb.readBits(5), hvcC.generalProfileIdc || 0);
      hvcC.generalProfileCompatibilityFlags = gb.readBits(32);
      hvcC.generalConstraintIndicatorFlags = [gb.readBits(8), gb.readBits(8), gb.readBits(8), gb.readBits(8), gb.readBits(8), gb.readBits(8)];
      var generalLevelIdc = gb.readBits(8);
      if (generalTierFlag < hvcC.generalTierFlag) {
        hvcC.generalLevelIdc = generalLevelIdc;
      } else {
        hvcC.generalLevelIdc = Math.max(generalLevelIdc, hvcC.generalLevelIdc || 0);
      }

      var subLayerProfilePresentFlag = [];
      var subLayerLevelPresentFlag = [];
      for (var j = 0; j < maxSubLayersMinus1; j++) {
        subLayerProfilePresentFlag[j] = gb.readBits(1);
        subLayerLevelPresentFlag[j] = gb.readBits(1);
      }

      if (maxSubLayersMinus1 > 0) {
        gb.readBits((8 - maxSubLayersMinus1) * 2);
      }

      for (var i = 0; i < maxSubLayersMinus1; i++) {
        if (subLayerProfilePresentFlag[i] !== 0) {
          gb.readBits(2);
          gb.readBits(1);
          gb.readBits(5);

          gb.readBits(16);
          gb.readBits(16);

          gb.readBits(4);

          gb.readBits(16);
          gb.readBits(16);
          gb.readBits(12);
        }
        if (subLayerLevelPresentFlag[i] !== 0) {
          gb.readBits(8);
        }
      }

      return {
        general_profile_space: hvcC.generalProfileSpace,
        general_tier_flag: hvcC.generalTierFlag,
        general_profile_idc: hvcC.generalProfileIdc,
        general_level_idc: hvcC.generalLevelIdc
      };
    }
  }, {
    key: '_skipScalingList',
    value: function _skipScalingList(gb, count) {
      var lastScale = 8;
      var nextScale = 8;
      var deltaScale = 0;
      for (var i = 0; i < count; i++) {
        if (nextScale !== 0) {
          deltaScale = gb.readSEG();
          nextScale = (lastScale + deltaScale + 256) % 256;
        }
        lastScale = nextScale === 0 ? lastScale : nextScale;
      }
    }
  }, {
    key: 'getProfileString',
    value: function getProfileString(profileIdc) {
      switch (profileIdc) {
        case 66:
          return 'Baseline';
        case 77:
          return 'Main';
        case 88:
          return 'Extended';
        case 100:
          return 'High';
        case 110:
          return 'High10';
        case 122:
          return 'High422';
        case 244:
          return 'High444';
        default:
          return 'Unknown';
      }
    }
  }, {
    key: 'getLevelString',
    value: function getLevelString(levelIdc) {
      return (levelIdc / 10).toFixed(1);
    }
  }, {
    key: 'getChromaFormatString',
    value: function getChromaFormatString(chroma) {
      switch (chroma) {
        case 420:
          return '4:2:0';
        case 422:
          return '4:2:2';
        case 444:
          return '4:4:4';
        default:
          return 'Unknown';
      }
    }
  }, {
    key: 'toVideoMeta',
    value: function toVideoMeta(spsConfig) {
      var meta = {};
      if (spsConfig && spsConfig.codec_size) {
        meta.codecWidth = spsConfig.codec_size.width;
        meta.codecHeight = spsConfig.codec_size.height;
        meta.presentWidth = spsConfig.present_size.width;
        meta.presentHeight = spsConfig.present_size.height;
      } else if (spsConfig.width && spsConfig.height) {
        meta.codecWidth = spsConfig.width;
        meta.codecHeight = spsConfig.height;
        meta.presentWidth = spsConfig.width;
        meta.presentHeight = spsConfig.height;
      }

      meta.profile = spsConfig.profile_string;
      meta.level = spsConfig.level_string;
      meta.bitDepth = spsConfig.bit_depth;
      meta.chromaFormat = spsConfig.chroma_format;

      // meta.parRatio = {
      //   width: spsConfig.par_ratio.width,
      //   height: spsConfig.par_ratio.height
      // }

      // meta.frameRate = spsConfig.frame_rate

      // let fpsDen = meta.frameRate.fps_den
      // let fpsNum = meta.frameRate.fps_num
      // meta.refSampleDuration = Math.floor(meta.timescale * (fpsDen / fpsNum))
      return meta;
    }
  }]);

  return SPSParser;
}();

export default SPSParser;